export function ensuredDefined<T> (item: T | undefined, message?: string): T {
  if (item === undefined) {
    throw new Error(message ?? 'item is undefined')
  }
  return item
}
